export const iconFontAwesomeArrowsCircleLeft = (
	<i className="fa-solid fa-circle-left"></i>
);
